import { Image } from 'apis/entities/image.entity'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader
import { Carousel } from 'react-responsive-carousel'
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import arrowLeft from 'images/arrow-left.svg'
import arrowRight from 'images/arrow-right.svg'
import { ButtonCopy } from 'components/ButtonCopy'
import Svg, { Icon, IconClass } from '../components/Svg'

interface ImageCarouselProps {
  images: Image[]
  selectedId: string
  hidden: boolean
  onCopy: (url: string) => void
  onClose?: () => void
  selectedImageIds?: string[]
  onSelectImage?: (imageId: string, checked: boolean) => void
}

export default function ImageCarousel(props: ImageCarouselProps) {
  const [selectedImage, setSelectedImage] = useState<Image>(
    props.images.find((x) => x.id === props.selectedId) || props.images[0],
  )

  const onChange = (index: number, item: any) => {
    const image = props.images[index]
    setSelectedImage(image)
  }
  useEffect(() => {
    setSelectedImage(
      props.images.find((x) => x.id === props.selectedId) || props.images[0],
    )
  }, [props.selectedId, props.images])

  if (props.hidden) return null

  // Modal content to be portaled
  const modalContent = (
    <>
      <div
        className="bg-white bg-opacity-70"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 999,
        }}
        onClick={(event) => {
          props.onClose?.()
        }}
      ></div>
      <div
        data-testid="image-carousel"
        className="image-carousel bg-white bg-opacity-70"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
        }}
      >
        <div
          style={{
            zIndex: 1001,
          }}
        >
          <div
            className="relative bg-white px-6 pt-3"
            style={{
              zIndex: 1002,
              width: 936,
              boxShadow: `0px 627px 176px 0px rgba(0, 0, 0, 0.00), 
                0px 401px 161px 0px rgba(0, 0, 0, 0.01), 
                0px 226px 135px 0px rgba(0, 0, 0, 0.05), 
                0px 100px 100px 0px rgba(0, 0, 0, 0.09), 
                0px 25px 55px 0px rgba(0, 0, 0, 0.10)`,
              overflow: 'hidden',
            }}
            onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
              event.stopPropagation()
            }
          >
            <style>
              {`
                .image-carousel button.carousel-control-next {
                  margin-right: -0px;
                }
                .image-carousel .carousel-root {
                  margin-left: 0px;
                  margin-right: 0px;
                }
                .image-carousel .slider-wrapper {
                  padding-left: 42px;
                  padding-right: 42px;
                }
              `}
            </style>
            <div className="flex justify-end gap-9">
              {/* Checkbox for image selection (Manage mode) */}
              {props.selectedImageIds &&
                props.onSelectImage &&
                selectedImage && (
                  <div className="cursor-pointer">
                    <input
                      type="checkbox"
                      checked={props.selectedImageIds.includes(
                        selectedImage.id,
                      )}
                      onChange={(e) =>
                        props.onSelectImage &&
                        props.onSelectImage(selectedImage.id, e.target.checked)
                      }
                      className="mr-2"
                      data-testid="checkbox-image-carousel"
                    />
                  </div>
                )}
              <div
                className="mb-0.5 mr-[-8px] mt-[-6px] cursor-pointer"
                onClick={props.onClose}
                data-testid="btn-close"
              >
                <Svg
                  icon={Icon.Close}
                  className={IconClass.FillBlack2}
                  width={30}
                />
              </div>
            </div>
            <Carousel
              // get index instead of id
              selectedItem={props.images.findIndex(
                (x) => x.id === props.selectedId,
              )}
              showThumbs={false}
              showArrows={true}
              showIndicators={false}
              dynamicHeight={true}
              infiniteLoop={true}
              width={'100%'}
              statusFormatter={(current, total) => `${current}/${total}`}
              renderArrowPrev={(onClickHandler, hasPrev, label) => {
                return (
                  <button
                    data-testid="btn-prev"
                    onClick={onClickHandler}
                    type="button"
                    className="control-arrow carousel-control-prev"
                  >
                    <img src={arrowLeft} className="mb-10" alt="" />
                  </button>
                )
              }}
              renderArrowNext={(onClickHandler, hasNext, label) => {
                return (
                  <button
                    data-testid="btn-next"
                    onClick={onClickHandler}
                    type="button"
                    className="control-arrow carousel-control-next"
                  >
                    <img src={arrowRight} className="mb-10" alt="" />
                  </button>
                )
              }}
              onChange={onChange}
            >
              {props.images.map((image, index) => {
                return (
                  <div key={index} className="bg-gray-300">
                    <img
                      alt=""
                      src={image.url}
                      className="h-[60vh] object-scale-down"
                    />
                  </div>
                )
              })}
            </Carousel>

            <div className="mb-[24px] mt-[24px] flex justify-center">
              <div className="flex items-center">
                <a
                  href={selectedImage.url}
                  className="font-roboto text-secondaryIndigo hover:text-purple"
                  target="_blank"
                  rel="noreferrer"
                >
                  {selectedImage.url}
                </a>
                <ButtonCopy url={selectedImage.url} onClick={props.onCopy} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )

  // Use portal to render modal at the end of body
  return ReactDOM.createPortal(modalContent, document.body)
}
